import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from '../../../../components';

const SoapForm = ({
	isOpen,
	inProgress,
	evisit,
	onFieldChange,
	onSaveVisit,
	isUpdating,
}) => {
	const [subjective, setSubjective] = useState(evisit.evisit_subjective || '');
	const [objective, setObjective] = useState(evisit.evisit_objective || '');
	const [assessment, setAssessment] = useState(evisit.evisit_assessment || '');
	const [patient_instructions, setPatientInstructions] = useState(
		evisit.patient_instructions || ''
	);

	return (
		<React.Fragment>
			<div className="form-group">
				<label className="control-label">Subjective</label>
				<div>
					{isOpen ? (
						<textarea
							className="form-control subjective"
							disabled={!inProgress || isUpdating}
							placeholder={inProgress ? '' : 'Start Visit to enable SOAP'}
							rows={4}
							value={subjective}
							onChange={({ target }) => setSubjective(target.value)}
							onBlur={() => onFieldChange('evisit_subjective', subjective)}
						/>
					) : (
						<p className="form-control-static">{subjective}</p>
					)}
				</div>
			</div>
			<div className="form-group">
				<label className="control-label">Objective</label>
				<div>
					{isOpen ? (
						<textarea
							className="form-control objective"
							rows={4}
							disabled={!inProgress || isUpdating}
							placeholder={inProgress ? '' : 'Start Visit to enable SOAP'}
							value={objective}
							onChange={({ target }) => setObjective(target.value)}
							onBlur={() => onFieldChange('evisit_objective', objective)}
						/>
					) : (
						<p className="form-control-static">{objective}</p>
					)}
				</div>
			</div>
			<div className="form-group">
				<label className="control-label">Assessment</label>
				<div>
					{isOpen ? (
						<textarea
							className="form-control assessment"
							rows={4}
							disabled={!inProgress || isUpdating}
							placeholder={inProgress ? '' : 'Start Visit to enable SOAP'}
							value={assessment}
							onChange={({ target }) => setAssessment(target.value)}
							onBlur={() => onFieldChange('evisit_assessment', assessment)}
						/>
					) : (
						<p className="form-control-static">{assessment}</p>
					)}
				</div>
			</div>
			<div className="form-group">
				<label className="control-label">Plan/Patient Instructions</label>
				<div>
					{isOpen ? (
						<textarea
							className="form-control instructions"
							rows={4}
							disabled={!inProgress || isUpdating}
							placeholder={inProgress ? '' : 'Start Visit to enable SOAP'}
							value={patient_instructions}
							onChange={({ target }) => setPatientInstructions(target.value)}
							onBlur={() =>
								onFieldChange('patient_instructions', patient_instructions)
							}
						/>
					) : (
						<p className="form-control-static">{patient_instructions}</p>
					)}
				</div>
				{isOpen && (
					<div className="mt text-right">
						<Button
							title="Save"
							disabled={!inProgress || isUpdating}
							onClick={onSaveVisit}
							primary
							className="save-evisit"
						/>
					</div>
				)}
			</div>
		</React.Fragment>
	);
};

SoapForm.propTypes = {
	inProgress: PropTypes.bool,
	isOpen: PropTypes.bool,
	evisit: PropTypes.object,
	onFieldChange: PropTypes.func.isRequired,
	onSaveVisit: PropTypes.func.isRequired,
	isUpdating: PropTypes.bool,
};

export default SoapForm;
